import React, { useState, useEffect } from "react";
import { FaSolarPanel, FaTools, FaCheckCircle, FaBolt } from "react-icons/fa";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./InstallationCommissioning.css";

function InstallationCommissioning() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const carouselImages = [
    "https://images.pexels.com/photos/4254167/pexels-photo-4254167.jpeg",
    "https://images.pexels.com/photos/9875441/pexels-photo-9875441.jpeg",
    "https://images.pexels.com/photos/4254167/pexels-photo-4254167.jpeg",
    "https://images.pexels.com/photos/9875441/pexels-photo-9875441.jpeg",
  ];

  useEffect(() => {
    const autoScrollTimer = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
    }, 4000);

    return () => clearInterval(autoScrollTimer);
  }, [carouselImages.length]);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? carouselImages.length - 1 : prev - 1
    );
  };
  return (
    <>
    <section className="ic-section">
      <div className="ic-header">
        <h1>I&C – Installation & Commissioning</h1>
        <p>
          At <strong>Luxman Solar Energy</strong>, we ensure every solar system is
          installed with precision and commissioned for peak performance from
          day one.
        </p>
      </div>

      <div className="ic-grid">
        {/* Installation */}
        <div className="ic-card">
          <img
            src="https://images.pexels.com/photos/4254167/pexels-photo-4254167.jpeg"
            alt="Solar Installation"
          />
          <h2>🔧 Installation</h2>
          <p>
            Our skilled technicians handle the precise placement and secure
            mounting of solar panels, inverters, and electrical components while
            following strict safety standards.
          </p>
          <ul>
            <li>Panel & inverter installation</li>
            <li>Electrical cabling & earthing</li>
            <li>Structural safety & alignment</li>
            <li>Compliance with industry standards</li>
          </ul>
        </div>

        {/* Commissioning */}
        <div className="ic-card">
          <img
            src="https://images.pexels.com/photos/9875441/pexels-photo-9875441.jpeg"
            alt="Solar Commissioning"
          />
          <h2>⚙️ Commissioning</h2>
          <p>
            After installation, we conduct comprehensive testing to ensure the
            system meets design specifications and operates at optimal
            efficiency.
          </p>
          <ul>
            <li>Performance & efficiency testing</li>
            <li>Inverter configuration & calibration</li>
            <li>Electrical & safety checks</li>
            <li>System optimization & troubleshooting</li>
          </ul>
        </div>
      </div>

      <div className="ic-footer">
        <h3>Why Choose Our I&C Services?</h3>
        <p>
          Effective Installation & Commissioning improves system reliability,
          maximizes energy generation, and extends equipment lifespan.
        </p>
        <div className="ic-highlights">
          <div>⚡ Maximum Energy Output</div>
          <div>🛡️ Enhanced Safety & Reliability</div>
          <div>⏳ Long-Term Performance</div>
          <div>🌱 Sustainable Energy Future</div>
        </div>
      </div>
    </section>
     <section className="ic-section">
      <div className="container">
        <div className="section-header">
          <p>
            Professional installation and commissioning services to ensure
            maximum performance, safety, and long-term reliability of your
            solar power plant.
          </p>
        </div>
        <div className="ic-layout-wrapper">
          <div className="ic-grid-layout">
            <div className="ic-content">
              <div className="ic-item">
                <FaSolarPanel className="ic-icon" />
                <div>
                  <h4>Solar Installation</h4>
                  <p>
                    Accurate installation of solar panels, mounting structures,
                    inverters, and cabling following IEC and MNRE standards.
                  </p>
                </div>
              </div>

              <div className="ic-item">
                <FaTools className="ic-icon" />
                <div>
                  <h4>System Testing</h4>
                  <p>
                    Complete mechanical and electrical inspections including
                    string testing, insulation resistance, and polarity checks.
                  </p>
                </div>
              </div>

              <div className="ic-item">
                <FaBolt className="ic-icon" />
                <div>
                  <h4>Commissioning</h4>
                  <p>
                    Inverter configuration, grid synchronization, load testing,
                    and performance ratio (PR) verification.
                  </p>
                </div>
              </div>

              <div className="ic-item">
                <FaCheckCircle className="ic-icon" />
                <div>
                  <h4>Safe & Reliable Operation</h4>
                  <p>
                    Ensuring the system is fully operational, compliant, and
                    optimized for long-term energy generation.
                  </p>
                </div>
              </div>
            </div>
            <div className="ic-sidebar-images">
              <div className="carousel-container">
                <img
                  src={carouselImages[currentImageIndex]}
                  alt="Installation Carousel"
                  className="carousel-main-image"
                />
                <button className="carousel-btn carousel-btn-prev" onClick={prevImage}>
                  <ChevronLeft size={24} />
                </button>
                <button className="carousel-btn carousel-btn-next" onClick={nextImage}>
                  <ChevronRight size={24} />
                </button>
              </div>
              <div className="carousel-dots">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${index === currentImageIndex ? "active" : ""}`}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
    
  );
}

export default InstallationCommissioning;
